export const app: { name: string; description: string; keywords: Array<string> } = {
  name: 'NIC Industries',
  description:
    'NIC® manufactures industry-leading coatings that are sold worldwide. CERAKOTE®, PRISMATIC POWDERS®, & PERFORMANCE MATERIALS® operate as separate divisions of NIC®.',
  keywords: ['NIC', 'Web', 'Industrial Coatings', 'Cerakote', 'Prismatic'],
}

export const domainName: string = 'NIC Industries'

export const phone: string = '866-774-7628'

interface Address {
  street: string
  city: string
  state: string
  zip: string
}

export const address: Address = {
  street: '7050 6th Street',
  city: 'White City',
  state: 'OR',
  zip: '97503',
}
